import React from "react";
import {IconButton} from "@mui/material";
import {text} from "../components/util/constants";

/**
 * Send dialog of a quotation answering a StackR quotation request: the
 * quotation goes through StackR, so there is no recipient to choose.
 */
export default function StackRSendDialog({requestNumber, sending, onCancel, onSend}) {
    return (
        <div className={"quotation-form flex-column"}>
            <h2>Envoi via StackR</h2>
            <div className={"secondary-section"}>
                <p>Ce devis répond à la demande de devis <b>{requestNumber}</b> du client.</p>
                <p>Il sera transmis par StackR (GDM). Aucun mail ne sera envoyé.</p>
            </div>
            <div className={"flex-row"}>
                <IconButton className={"action-btn cancel"} onClick={onCancel}>{text.CANCEL}</IconButton>
                <IconButton className={"action-btn validation"} disabled={sending} onClick={onSend}>Envoyer via StackR</IconButton>
            </div>
        </div>
    )
}
